import _ from 'lodash';
import React from 'react';
import { getDocTypes } from '../../../api/DocumentsService';
import useNotifications from '../../../_lib/notifications/useNotifications';

/**
 * @name withUWDocDependencies
 * @description This component is meant to enable the data combination and preperation for rendering
 */
export const withUWDocDependencies = () => {
  return (Component: any) => {
    return (props: any) => {
      const notifications = useNotifications();
      const [data, setData] = React.useState('');
      React.useEffect(() => {
        getDocTypes({})
          .then((response: any) => {
            const array = _.map(response.data, (v, k) => {
              return {
                label: k,
                value: v,
              };
            });
            // @ts-expect-error TS(2345): Argument of type '{ label: string; value: any; }[]... Remove this comment to see the full error message
            setData(array);
          })
          .catch(() => {
            notifications.error('Failed to load doc types!');
          });
      }, [notifications]);

      if (data) {
        return <Component {...props} docTypes={data} />;
      }
      return null;
    };
  };
};
